import Vue from 'vue'
import axios from 'axios'
import request from "@/utils/request"
// 引入样板数组
import dataConfig from "@/utils/data.js"
import MD from "@/utils/md5"
let flag = true

export default {
    isLoading: true,
    // 存Session数据
    saveSession (key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value))
    },
    // 取Session数据
    getSession (key) {
        return JSON.parse(window.sessionStorage.getItem(key))
    },
    // 删除Session指定key的数据
    removeSession (key) {
        window.sessionStorage.removeItem(key)
    },
    // 存localStorage数据
    saveLocal (key, value) {
        window.localStorage.setItem(key, JSON.stringify(value))
    },
    // 取localStorage数据
    getLocal (key) {
        return JSON.parse(window.localStorage.getItem(key))
    },
    // 删除localStorage指定key的数据
    removeLocal (key) {
        window.localStorage.removeItem(key)
    },
    // 判断值的类型
    getValueType (value) {
        var type = ''
        if (typeof value != 'object') {
            type = typeof value
        } else {
            if (value instanceof Array) {
                type = 'array'
            } else {
                if (value instanceof Object) {
                    type = 'object'
                } else {
                    type = 'null'
                }
            }
        }
        return type
    },
    // 判空
    isEmpty (data) {
        let key = this.getValueType(data)
        if (key == 'object') {
            let arr = Object.values(data)
            if (arr.indexOf('') != -1 || arr.indexOf('undefined') != -1) {
                return true
            } else {
                return false
            }
            // (Array.isArray(data) && data.length == 0) || (Object.prototype.isPrototypeOf(data) && Object.keys(data).length == 0))
        }
        if (key == 'undefined' || key == 'null') {
            return true
        }
        if (key == 'number' || key == 'string' || key == 'array') {
            if (data.length == 0) {
                return true
            } else {
                return false
            }
        }
        if (key == 'function') {
            return true
        }
    },
    // js小数乘法 arg1：被乘数（接受小数和整数） arg2：乘数（接受小数和整数） fix: 乘积保留几位（接受正负整数以及0）
    accMul (arg1, arg2, fix) {
        if (!parseInt(fix) == fix) {
            return
        }
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString()
        try { m += s1.split(".")[1].length } catch (e) { }
        try { m += s2.split(".")[1].length } catch (e) { }
        if (m > fix) {
            return (Math.round(Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m - fix)) / Math.pow(10, fix))
        } else if (m <= fix) {
            return (Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)).toFixed(fix)
        } else {
            return (arg1 * arg2).toFixed(fix)
        }
    },
    accAdd (arg1, arg2) {
        var r1, r2, m, c
        try {
            r1 = arg1.toString().split(".")[1].length
        }
        catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split(".")[1].length
        }
        catch (e) {
            r2 = 0
        }
        c = Math.abs(r1 - r2)
        m = Math.pow(10, Math.max(r1, r2))
        if (c > 0) {
            var cm = Math.pow(10, c)
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""))
                arg2 = Number(arg2.toString().replace(".", "")) * cm
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm
                arg2 = Number(arg2.toString().replace(".", ""))
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""))
            arg2 = Number(arg2.toString().replace(".", ""))
        }
        return (arg1 + arg2) / m
    },
    // 遍历权限
    ergodics (name) {
        let obj = []
        let array = this.getLocal("Button_Power")
        // console.log(array)
        for (let index = 0; index < array.length; index++) {
            const element = array[index]
            obj.push(element)
            if (element.Name == name) {
                return obj[obj.length - 1]
            }
        }
    },
    // 遍历权限
    circulate (name, names) {
        let array = this.ergodics(names).List
        let obj = []
        for (let index = 0; index < array.length; index++) {
            const element = array[index]
            obj.push(element)
            if (element.Action == name) {
                return obj[obj.length - 1]
            }
        }
    },
    // 权限
    Jurisdiction (val, val1, val2) {
        let array = this.Jurisdictions(val).List
        if (array === false) {
            return false
        } else {
            for (let index = 0; index < array.length; index++) {
                const item = array[index]
                if (item.Action == '查看') {
                    return this.Jurisdictionsg(array, val1, val2)
                }
            }
        }

    },
    Jurisdictions (val) {
        let obj = []
        let array = this.getLocal("Button_Power")
        array.map(item => {
            if (item.Name == val) {
                obj.push(item)
            }
        })
        return obj[0]
    },
    Jurisdictionsg (val, val1, val2) {

        if (val2 == undefined) {
            for (let index = 0; index < val.length; index++) {
                const element = val[index]
                if (element.Action == val1) {
                    return element.Status
                }
            }
        } else {
            // console.log('我要执行关联权限操作');
            return false
        }

    },
    // 导出  jparams={} Url 你导出的文件访问地址  Model  表单配置model
    exportclick (jparams, Url, Model) {
        let jparams_deleteRow = {
            jparams: JSON.stringify(jparams),
            Url: 'http://118.190.210.223:8090' + Url,
            Model: Model
        }
        request
            .post("/index/Export_Excel/ExportFile", jparams_deleteRow)
            .then(res => {
                // console.log(res);
                // window.open(res.download_url);

                const a = document.createElement('a')
                a.setAttribute('download', '')
                a.setAttribute('href', res.download_url)
                a.click()

            })
    },
    // 导入
    Importclick (Model = "Goods", ParentNo = 0, file) {
        let jparam = {
            user_id: local.get("userid"), //用户id
            session_id: local.get("sessionid"), //用户凭证
            Model: Model,// 导入Excel的模块名称
            ParentNo: ParentNo //仓库ID，导入库存期初使用
        }
        let jparams = JSON.stringify(jparam)
        let jparams_search = { jparams: jparams }

        request
            .post("/index/Export_Excel/ImportFile", jparams_search)
            .then(res => {
                // console.log(res);
            })

    },
    // 下载示例
    Download (Url) {
        let Urls = {
            Goods: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoGoods.xlsx",// 商品
            ClientA: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoClientA.xlsx",// 客户
            ClientB: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoClientB.xlsx",// 供应商
            IniCustomer: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoIniCustomer.xlsx",// 应收期初
            IniGoods: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoIniGoods.xlsx",// 商品期初
            IniSupplier: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoIniSupplier.xlsx",// 应付期初
            ImportSerialNo: "http://118.190.210.223:8090/index/Export_Excel/download_demo_file?filename=DemoSerialNo.xlsx",// 序列号
        }
        window.open(Urls[Url])
    },
    // 按钮权限
    Buttonclick () {
        if (this.getSession("Button_click") === null) {
            setTimeout(() => { this.saveSession("Button_click", true) })
            return true
        }
        if (this.getSession("Button_click")) {
            setTimeout(() => { this.saveSession("Button_click", false) })
            setTimeout(() => { this.saveSession("Button_click", true) }, 1000)
            return true
        } else {
            setTimeout(() => { this.saveSession("Button_click", true) })
            return false
        }


    },
    XModalmessage (_this, message = '未知错误请重试错误', status = false) {
        // 参数一 必须为 this  必要参数   参数二 提示内容 默认为参数错误 String类型   参数三 可为Boolean String类型  true 图标为真确提示  false 图标为错误提示  String类型 vx表格自行添加
        let accMul = ''
        if (status === true) {
            accMul = 'success'
        } else if (status === false) {
            accMul = 'error'
        } else {
            accMul = status
        }
        _this.$XModal.message({
            message: message,
            status: accMul,
            iconStatus: "fa fa-thumbs-up",
            id: "unique1"
        })
    },
    // 弹出信息提示（防止重复点击）
    popMessage (_this, text, model) {
        // function(text,model) {
        if (flag) {
            flag = false
            //下面添加需要执行的事件
            _this.$message({
                message: text,
                type: model
            })
            //定时器
            setTimeout(function () {
                flag = true
            }, 3000)
        }
        // }

    },
    // 通过单据类VchType 查找返回单据当前的信息（信息为对象，包含名字和路由名）
    findOrderName (val) {
        let pageInfor = dataConfig.pageList.find(item => {
            return item.VchType == val
        })
        return pageInfor
    },
    //过滤掉单据中的空行商品元素
    filterGoods (data) {
        let goods = []
        let emptyData = {
            PtypeId: "", //商品Id
            FullName: "", //商品名称
            Qty: "", //数量
            AQty: "", //可用库存
            ShowPrice: "", //单价
            Total: "", //金额
            Memo: "", //备注
            Discount: "", //折扣
            DiscountPrice: "", //折后单价
            DiscountTotal: "", //折后金额
            Tax: "", //税率
            TaxPrice: "", //产品含税单价
            WithTaxTotal: "", //产品含税金额
            TaxTotal: "", //税额
            ChargePrice: "", //费用单价
            ChargeTotal: "", //费用金额
            Unit: "", //单位id
            UnitName: "", //单位名称
            PStutas: "", //销售单才传值,赠品标记,1-赠品,0-非赠品
            BString1: "", //备用字段1
            BString2: "", //备用字段2
            BString3: "", //备用字段3
            BString4: "", //备用字段4
            BString5: "", //备用字段5
            BaseNo: "", //商品编号(只显示)
            Standards: "", //规格(只显示)
            Model: "", //型号(只显示)
        }
        data.filter(item => {
            if (item.FullName != "" && item.FullName != "") {

                goods.push(item)
            }
        })
        if (goods.length == 0) {
            goods.splice(0, 1, data[data.length - 1])
        }
        return goods
    },
    // 时间加
    DateAdds (interval, number, row, operation) {
        /*
         *   功能:实现VBScript的DateAdd功能.
         *   参数:interval,字符串表达式，表示要添加的时间间隔.
         *   参数:number,数值表达式，表示要添加的时间间隔的个数.
         *   参数:row,选择的时间.
         *   返回:新的时间对象.
         *   var   now   =   new   Date(row);
         *   var   newDate   =   DateAdd( "d ",5,now);
         *---------------   DateAdd(interval,number,date)   -----------------
         */

        var date = new Date(row)
        if (interval == "d" && operation) {
            date.setDate(date.getDate() + number)
            return format(date, "yyyy-MM-dd")
        }
        if (interval == "m" && operation) {
            date.setMonth(date.getMonth() + number)
            return format(date, "yyyy-MM-dd")
        }
        if (interval == "y" && operation) {
            date.setFullYear(date.getFullYear() + number)
            return format(date, "yyyy-MM-dd")
        }
        if (interval == "d" && !operation) {
            date.setDate(date.getDate() - number)
            return format(date, "yyyy-MM-dd")
        }
        if (interval == "m" && !operation) {
            date.setMonth(date.getMonth() - number)
            return format(date, "yyyy-MM-dd")
        }
        if (interval == "y" && !operation) {
            date.setFullYear(date.getFullYear() - number)
            return format(date, "yyyy-MM-dd")
        }
        function format (time, format) {
            var t = new Date(time)
            var tf = function (i) {
                return (i < 10 ? "0" : "") + i
            }
            return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
                switch (a) {
                    case "yyyy":
                        return tf(t.getFullYear())
                    case "MM":
                        return tf(t.getMonth() + 1)
                    case "mm":
                        return tf(t.getMinutes())
                    case "dd":
                        return tf(t.getDate())
                    case "HH":
                        return tf(t.getHours())
                    case "ss":
                        return tf(t.getSeconds())
                }
            })
        }

    },
    // 处理打印表头表尾数据
    dealPrintData (name, val, data) {
        // 返回整理的一条数据
        let printData = { name: escape(name), value: '' }
        data.find(function (item) {
            if (item.Name == name) {
                if (item.Name === '时间段') {
                    return printData = { name: escape(name), value: escape(val) }
                } else {
                    return printData = { name: escape(item.Rename), value: escape(val) }
                }
            }
        })
        return printData
    },
    // 处理表格数据
    dealPrintTableData (headData, tableData) {
        let newObj = []//所有数据
        // 处理数据为空时下面map没有表头数据的问题
        if (tableData.length == 0) {
            tableData = [{}]
        }
        tableData.map((item1, index) => {
            // if (item1.PtypeId) {
            let rowData = []//每一行的数据
            rowData.push({ name: escape("行号"), value: escape(index + 1) })
            headData.map(item2 => {
                rowData.push({ name: escape(item2.Rename), value: escape(item1[item2.Key]) })
            })
            newObj.push(rowData)
            // }
        })
        return newObj
    },
    // 封装axios请求函数对跨域的url进行处理
    adjustPrint (pramgs, _this) {
        console.log(pramgs)
        axios.post('http://127.0.0.1:8080/datasnap/rest/TSMWebPrt/echo/', JSON.stringify(pramgs))
            .then(function (response) {
                // console.log(response);
                _this.$message({
                    message: '已关闭打印管理器',
                    type: 'success'
                })
            })
            .catch(function (error) {
                _this.$alert('你未打开打印管理服务器或未安装打印管理器，请到升达官网下载！', '打印未正确进行', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                            type: 'warning',
                            message: `action: ${action}`
                        })
                    }
                })
                // console.log(error);
            })
    },
    // 返回满足有一个条件的
    conditionSatisfied (data, condition) {
        /* 
            data：必要参数  一个数组 
            condition：必要参数 条件
        */
        // for (const item of data) {
        // console.log(item);

        // }

    },
    // 打开表头 折扣
    tableConfigData (data, ObtainHeader, _this) {
        for (let index = 0; index < data.length; index++) {
            if (Number(data[index].Discount) != 1) {
                ObtainHeader.map(item => {
                    if (
                        item.Key == "Discount" ||
                        item.Key == "DiscountTotal" ||
                        item.Key == "DiscountPrice"
                    ) {
                        if (item.Key == "Discount" && item.Show == false) {
                            this.popMessage(
                                _this,
                                "当前折扣不为 1 已自动显示折扣，折扣单价，折扣金额",
                                "warning"
                            )
                        }
                        item.Show = true
                        return
                    }
                })
            }
            if (Number(data[index].Tax) != 0) {
                ObtainHeader.map(item => {
                    if (
                        item.Key == "Tax" ||
                        item.Key == "TaxPrice" ||
                        item.Key == "WithTaxTotal" ||
                        item.Key == "TaxTotal"
                    ) {
                        if (item.Key == "Tax" && item.Show == false) {
                            this.popMessage(
                                _this,
                                '当前税率不为 0 已自动显示税率，含税单价，价税合计，税额',
                                "warning"
                            )
                        }
                        item.Show = true
                        return
                    }
                })
            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/utils/tool.js